/*
 * Helper methods for data shared between exchange screens.
 * */

/*
 * Gets the total number of tickets purchased.
 * */
export const getTotalTicketQuantity = tickets => {
  return tickets.reduce(
    (accumulator, currentItem) => accumulator + +currentItem.ticketQnty,
    0
  )
}

/*
 * Gets the sum of all of the tickets passed in.
 * */
export const getTotalTicketCost = tickets => {
  return tickets.reduce(
    (accumulator, currentItem) => accumulator + +currentItem.totalPrice,
    0
  )
}

export default {
  getTotalTicketQuantity,
  getTotalTicketCost
}
